import { render } from "./TrendingStatSummary.vue?vue&type=template&id=71a713b3&scoped=true"
import script from "./TrendingStatSummary.vue?vue&type=script&lang=js"
export * from "./TrendingStatSummary.vue?vue&type=script&lang=js"

import "./TrendingStatSummary.vue?vue&type=style&index=0&id=71a713b3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a713b3"]])

export default __exports__